module.exports = __webpack_public_path__ + "img/HeaderSecciones.4ab26b7c.png";